import ImageDisplay from './ImageDisplay';
import LoadingIndicator from './LoadingIndicator';
import LimitReachedMessage from './LimitReachedMessage';
import { useState } from 'react';
import PricingModal from '@/components/PricingModal';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  image?: string;
  imageId?: string;
  previewImage?: string;
  isGeneratingImage?: boolean;
  imageGenerationStartTime?: number;
  model?: string;
  userPrompt?: string;
  promptId?: string;
  rating?: 'thumbs_up' | 'thumbs_down' | null;
  error?: string;
  hasError?: boolean;
}

interface AssistantMessageProps {
  message: Message;
  sessionTitle?: string;
  sessionId?: string;
  onRegenerate?: (model: string, prompt: string, promptId?: string, modelObject?: any) => void;
  allImageMessages?: Message[];
  currentImageIndex?: number;
}

export default function AssistantMessage({ message, sessionTitle = 'Image', sessionId, onRegenerate, allImageMessages, currentImageIndex }: AssistantMessageProps) {
  const [showPricingModal, setShowPricingModal] = useState(false);
  
  // Check if this is a limit reached error
  const isLimitReached = message.hasError && message.error?.includes('credit limit');
  
  return (
    <>
      <div className="flex justify-start mb-6" id={message.promptId}>
        <div className="sm:max-w-[70%] w-full min-w-[250px] lg:min-w-[300px]">
          {message.content && (
            <div className="text-gray-800 dark:text-gray-200 prose dark:prose-invert prose-sm text-sm max-w-none mb-4">
              {message.content}
            </div>
          )}
          
          {isLimitReached ? (
            <LimitReachedMessage onUpgradeClick={() => setShowPricingModal(true)} />
          ) : message.hasError && message.error ? (
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-5 h-5 rounded-full bg-red-500 dark:bg-red-600 flex items-center justify-center">
                  <span className="text-white dark:text-white text-xs font-bold">!</span>
                </div>
                <h3 className="text-red-800 dark:text-red-400 font-medium text-sm">Error generating image</h3>
              </div>
              <p className="text-red-700 dark:text-red-300 text-sm">{message.error}</p>
            </div>
          ) : null}

          {!message.hasError && (
            <ImageDisplay 
              message={message}
              sessionTitle={sessionTitle}
              sessionId={sessionId}
              onRegenerate={onRegenerate}
              allImageMessages={allImageMessages}
              currentImageIndex={currentImageIndex}
            />
          )}
        </div>
      </div>
      
      <PricingModal 
        open={showPricingModal} 
        onClose={() => setShowPricingModal(false)} 
      />
    </>
  );
}